import { createFragmentDefinition } from "core/utils";
import { fragment } from "./fragment";
export { prepRoute as prepProgramRoute } from "./route";
export { View as ProgramView } from "./View";
export var fragmentDefinition = createFragmentDefinition(fragment, "ProgramFragment");
export * from "./blocks";
